import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/material/form-field';

interface InputProps extends FormlyFieldProps {
  tooltip: string;
  placeholder: string;
  tbc: boolean;
  routedLabel?: RoutedLabel[];
}

interface RoutedLabel {
  text: string;
  route: string | string[];
  fragment?: string;
}

@Component({
    selector: 'lockton-apps-template-type',
    templateUrl: './template-type.component.html',
    styleUrls: ['./template-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TemplateTypeComponent extends FieldType<
  FieldTypeConfig<InputProps>
> {}
